import React from "react"
import { StaticImage } from "gatsby-plugin-image"//ローカルから画像を持ってくる
import { TitleAnimation } from '../index'
// import { LinkButton } from "../index"
// import { useBreakpoint } from 'gatsby-plugin-breakpoints'
import * as styles from "./RecruitCulture.module.scss"
import BgTop from "./RecruitCultureBgTop";
import BgBtm from "./RecruitCultureBgBtm";

const RecruitCulture = () => {

  // const breakpoints = useBreakpoint();

  const title1 = [
    { "id": 0, "text": "c" },
    { "id": 1, "text": "u" },
    { "id": 2, "text": "l" },
    { "id": 3, "text": "t" },
    { "id": 4, "text": "u" },
    { "id": 5, "text": "r" },
    { "id": 6, "text": "e" },
  ];

  return (
    <div className={styles.RecruitCulture}>
      <div className={styles.RecruitCulture__inner}>
        <TitleAnimation data={title1} className={`titleRubikCenter`} />
        <h2 className={`subH2`}>環境と制度</h2>
        <div className={styles.RecruitCulture__content}>
          <BgTop />
          <ul>
            <li>
              <div className={styles.RecruitCulture__num}>01</div>
              <div className={styles.RecruitCulture__img}>
                <StaticImage
                  src="../../images/recruit/top/culture1@2x.png"
                  alt="中途採用でもキャリアが活かせる組合です"
                  placeholder="blurred"
                />
              </div>
              <div className={styles.RecruitCulture__title}>
                中途採用でもキャリアが<br />
                活かせる組合です
              </div>
              <div className={styles.RecruitCulture__text}>
                当組合では、中途入組される職員も多く、年齢や社歴に関係無く入組後すぐに仲間として活躍することができ、様々なバックボーンに裏付けされた高い意識を持つ職員がいる環境の中で、キャリアを積むことができます。
              </div>
            </li>
            <li>
              <div className={styles.RecruitCulture__num}>02</div>
              <div className={styles.RecruitCulture__img}>
                <StaticImage
                  src="../../images/recruit/top/culture2@2x.png"
                  alt="教育・研修制度"
                  placeholder="blurred"
                />
              </div>
              <div className={styles.RecruitCulture__title}>
                教育・研修制度
              </div>
              <div className={styles.RecruitCulture__text}>
                社員の考え方・意識・スキルの向上を目指し、社員教育にも積極的に取り組んでいます。<br />
                目的や階層に合わせた研修ラインアップから選択受講できる研修制度や、社内検定制度、若手育成研修等もあります。
              </div>
            </li>
            <li>
              <div className={styles.RecruitCulture__num}>03</div>
              <div className={styles.RecruitCulture__img}>
                <StaticImage
                  src="../../images/recruit/top/culture3@2x.png"
                  alt="各種制度の充実"
                  placeholder="blurred"
                />
              </div>
              <div className={styles.RecruitCulture__title}>
                各種制度の充実
              </div>
              <div className={styles.RecruitCulture__text}>
                当組合で働くすべての人に性別や年齢、障害の有無、雇用形態等に関わりなく、やりがいを持って生き生きと働ける職場環境の形成を目指し、「誰でも活躍できるやまぐちの企業」に認定されています。
              </div>
            </li>
            <li>
              <div className={styles.RecruitCulture__num}>04</div>
              <div className={styles.RecruitCulture__img}>
                <StaticImage
                  src="../../images/recruit/top/culture4@2x.png"
                  alt="社員アンケートより"
                  placeholder="blurred"
                />
              </div>
              <div className={styles.RecruitCulture__title}>
                社内アンケートより
              </div>
              <div className={styles.RecruitCulture__text}>
                「職場の雰囲気がよく、年齢や役職にかかわりなくコミュニケーションがとりやすい」、｢様々な職場（部署・職種）があり、得意分野のスキルを活かせる｣といった声が多数上がっています。
              </div>
            </li>
          </ul>
          <BgBtm />
        </div>
      </div>
    </div>
  )
}
export default RecruitCulture

